{
  "Dashboard": "대시보드",
  "BlyCareShippingProte": "BlyCare 배송 보호",
  "LoadingBlyCare": "BlyCare 불러오는 중…",
  "LoadingWidgetSetting": "위젯 설정 불러오는 중…",
  "PreparingYourWorkspa": "작업 공간 준비 중",
  "Language": "언어",
  "English": "English",
  "EnglishDefault": "English (Default)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "설정 가이드",
  "CompletedOfTotalComp": "{{completed}}/{{total}} 완료",
  "Dismiss": "닫기",
  "MoreActions": "추가 작업",
  "ToggleSetupGuide": "설정 가이드 표시/숨기기",
  "ActivateAppEmbed": "앱 임베드 활성화",
  "ClickTheEnableButton": "1. 아래의 활성화 버튼을 클릭하여 Shopify 테마 편집기를 엽니다.",
  "BlyCareEmbedSection": "2. 왼쪽의 앱 임베드 섹션에서 BlyCare를 찾습니다. 토글이 켜져 있는지 확인합니다. 그런 다음 오른쪽 상단의 저장을 클릭합니다.",
  "Enable": "활성화",
  "PublishWidget": "위젯 게시",
  "PublishStorefront": "스토어프론트에 위젯을 게시하여 고객이 구매할 수 있도록 합니다.",
  "Publish": "게시",
  "SetProtectionFee": "보호 수수료 설정",
  "FeeYouWantToCharge": "고객에게 부과할 수수료를 설정합니다.",
  "Setup": "설정",
  "TestYourWidgetOnYour": "스토어에서 위젯 테스트",
  "AddAProductToYourCar": "장바구니에 상품을 추가하고 배송 보호 위젯이 표시되는지 확인합니다. 배송 보호를 선택한 다음 결제를 진행하고 결제 페이지에 배송 보호 상품이 포함되어 있는지 확인합니다.",
  "TestNow": "지금 테스트",
  "Working": "정상 작동 중",
  "NeedHelp": "도움말",
  "MarkAsCompleted": "완료로 표시",
  "AppStatus": "앱 상태",
  "AppEmbed": "앱 임베드",
  "EnableAppEmbedToDisp": "장바구니에 배송 보호를 표시하려면 앱 임베드를 활성화하세요.",
  "CartPage": "장바구니 페이지에 배송 보호를 표시합니다.",
  "CheckoutBlock": "결제 블록",
  "CheckoutPage": "결제 페이지에 배송 보호를 표시합니다.",
  "Active": "활성",
  "Inactive": "비활성",
  "Analytics": "분석",
  "Today": "오늘",
  "Last7Days": "최근 7일",
  "Last30Days": "최근 30일",
  "Last60Days": "최근 60일",
  "Last90Days": "최근 90일",
  "Last365Days": "최근 365일",
  "Custom": "사용자 지정",
  "Start": "시작",
  "End": "종료",
  "DateRange": "기간",
  "SelectedRange": "선택한 기간: {{range}}",
  "Cancel": "취소",
  "Save": "저장",
  "ChooseAStartDateOnOr": "종료 날짜와 같거나 이전인 시작 날짜를 선택하고, 오늘 이후의 날짜는 선택하지 마세요.",
  "PreviousMonth": "이전 달",
  "NextMonth": "다음 달",
  "ProtectionRevenue": "보호 매출",
  "ProtectedOrders": "보호된 주문",
  "ProtectedOrderRate": "보호 주문 비율",
  "LoadingAnalytics": "분석 불러오는 중…",
  "AnalyticsCouldNotLo": "분석을 불러올 수 없습니다",
  "RetryAnalytics": "분석 다시 시도",
  "Resources": "리소스",
  "HowDoesShippingProte": "배송 보호는 어떻게 작동하나요?",
  "BlyCareAddsAShipping": "BlyCare는 장바구니에 배송 보호 위젯을 추가합니다. 고객은 주문에 보호를 추가하도록 선택할 수 있습니다. 보호 수수료를 징수하는 판매자는 어떤 상황이 보장되는지 결정하고 해당 수수료로 청구를 처리합니다.",
  "DoesBlyCareCoverInsu": "BlyCare가 보험 청구를 보장하나요?",
  "NoBlyCareIsNotInsura": "아니요. BlyCare는 보험이 아니며 청구 금액을 지불하지 않습니다. BlyCare는 판매자가 자체 배송 보호 프로그램을 관리할 수 있도록 위젯과 도구만 제공합니다.",
  "EmailUs": "이메일 보내기",
  "LiveChat": "실시간 채팅",
  "HelpCenter": "도움말 센터",
  "Settings": "설정",
  "CheckoutWidget": "결제 위젯",
  "CartWidget": "장바구니 위젯",
  "PriceSetting": "가격 설정",
  "ProductSetting": "상품 설정",
  "AdminLanguage": "관리자 언어",
  "AdminLanguageTitle": "관리자 언어",
  "AdminLanguageHelp": "본인에게만 적용되는 앱 언어를 변경합니다. 고객에게는 영향을 주지 않습니다.",
  "AppLanguage": "앱 언어",
  "UnableToLoadSettings": "설정을 불러올 수 없습니다",
  "TryAgain": "다시 시도",
  "Discard": "버리기",
  "LoadingSettings": "설정 불러오는 중",
  "PageNotFound": "페이지를 찾을 수 없습니다",
  "ProductSettingsCould": "상품 설정을 저장할 수 없습니다.",
  "Fulfillment": "주문 처리",
  "FulfillmentHelp": "보호 상품이 처리됨으로 표시되는 시점을 선택합니다.",
  "ManuallyFulfill": "수동으로 처리",
  "MarkFulfilledWhenFir": "주문의 첫 번째 상품이 처리되면 처리됨으로 표시",
  "MarkFulfilledWhenAll": "주문의 다른 모든 상품이 처리되면 처리됨으로 표시",
  "MarkFulfilledImmedi": "주문 생성 직후 처리됨으로 표시",
  "Exclusions": "제외",
  "ExclusionsHelp": "보호가 적용되지 않아야 하는 경우를 선택합니다.",
  "ExclusionType": "제외 유형",
  "Select": "선택",
  "SelectedExclusions": "선택된 제외 항목",
  "RemoveName": "{{name}} 제거",
  "WhenExcluded": "제외 시",
  "HideWidget": "위젯 숨기기",
  "KeepWidgetButSkipThe": "위젯은 유지하고 수수료는 건너뛰기",
  "ExcludeProductType": "상품 유형 제외",
  "SearchProductType": "상품 유형 검색",
  "ExcludeSKU": "SKU 제외",
  "SearchSKU": "SKU 검색",
  "ExcludeCollection": "컬렉션 제외",
  "SearchCollection": "컬렉션 검색",
  "ExcludeMarket": "마켓 제외",
  "SearchMarket": "마켓 검색",
  "ExcludeLanguage": "언어 제외",
  "SearchLanguage": "언어 검색",
  "Add": "추가",
  "PriceSettingsCouldNo": "가격 설정을 저장할 수 없습니다.",
  "ShippingProtectionPr": "배송 보호 가격",
  "SetHowMuchPriceDoYou": "고객에게 부과할 가격을 설정하세요",
  "PricingMethod": "가격 책정 방식",
  "Fixed": "고정",
  "Percentage": "백분율",
  "UniversalProtectionP": "범용 보호 가격",
  "PercentageOfCartSubt": "장바구니 소계의 백분율",
  "EditCappedPrice": "상한 가격 편집",
  "ShippingProtectionFe": "배송 보호 수수료는 {{minPrice}} USD부터 시작하여 {{increment}} USD씩 증가하는 백분율로 계산되며, 최대 {{capped}} USD입니다.",
  "MinProtectionFee": "최소 보호 수수료",
  "IncrementAmount": "증가 금액",
  "CappedProtectionFee": "보호 수수료 상한",
  "AddTierPrice": "구간 가격 추가",
  "AddTier": "구간 추가",
  "TierPriceHelp": "장바구니 가격이 설정한 구간별 장바구니 가격 범위와 일치하지 않으면 이전 페이지에서 설정한 범용 가격이 적용됩니다.",
  "MinCartPrice": "최소 장바구니 가격",
  "MaxCartPrice": "최대 장바구니 가격",
  "ProtectionFee": "보호 수수료",
  "RemoveTier": "구간 제거",
  "Required": "필수",
  "ThisFieldIsRequired": "이 필드는 필수입니다.",
  "MustBeGreaterThanZero": "{{label}}은(는) 0보다 커야 합니다.",
  "MustBeOrLess": "{{label}}은(는) {{max}} 이하여야 합니다.",
  "AtMostTwoDecimals": "{{label}}은(는) 소수점 이하 2자리까지만 가능합니다.",
  "MustBeLargerThanMinC": "최소 장바구니 가격보다 커야 합니다",
  "MustBeLargerThanMaxC": "최대 장바구니 가격보다 커야 합니다",
  "MustBeSmallerThanMin": "최소 장바구니 가격보다 작아야 합니다",
  "Price": "가격",
  "MinimumPrice": "최소 가격",
  "Increment": "증가분",
  "CartPageWidget": "장바구니 페이지 위젯",
  "CheckoutPageWidget": "결제 페이지 위젯",
  "WidgetFormat": "위젯 형식",
  "TickerWidget": "일반 위젯",
  "CheckoutButtonWidget": "결제 버튼 위젯",
  "Text": "텍스트",
  "MainText": "메인 텍스트",
  "Title": "제목",
  "Description": "설명",
  "MainButtonText": "메인 버튼 텍스트",
  "SecondaryButtonText": "보조 버튼 텍스트",
  "EnabledDescription": "활성화 설명",
  "DisabledDescription": "비활성화 설명",
  "PleaseEnterTitle": "제목을 입력하세요",
  "PleaseEnterDescript": "설명을 입력하세요",
  "PleaseEnterMainButt": "메인 버튼 텍스트를 입력하세요",
  "PleaseEnterSecondar": "보조 버튼 텍스트를 입력하세요",
  "PleaseEnterEnabledD": "활성화 설명을 입력하세요",
  "PleaseEnterDisabled": "비활성화 설명을 입력하세요",
  "EGViewTerms": "예: 약관 보기",
  "EGHttpTerms": "예: https://terms.com",
  "Footer": "푸터",
  "FooterText": "푸터 텍스트",
  "FooterLink": "푸터 링크",
  "TooltipLink": "툴팁 링크",
  "FooterVisibility": "푸터 표시 여부",
  "TitleInfoVisibility": "제목 정보 표시 여부",
  "Disabled": "비활성화",
  "Enabled": "활성화",
  "Color": "색상",
  "ColorStyle": "색상 스타일",
  "SizeAndDisplay": "크기 및 표시",
  "IconSize": "아이콘 크기",
  "IconRadius": "아이콘 반경",
  "BorderSize": "테두리 크기",
  "BorderRadius": "테두리 반경",
  "HorizontalPadding": "가로 여백",
  "VerticalPadding": "세로 여백",
  "ToggleFormat": "토글 형식",
  "Switch": "스위치",
  "Checkbox": "체크박스",
  "Border": "테두리",
  "Background": "배경",
  "ProtectionDescript": "보호 설명",
  "MainButtonBackgrou": "메인 버튼 배경",
  "EnabledToggle": "활성화 토글",
  "DisabledToggle": "비활성화 토글",
  "Automatic": "자동",
  "Neutral": "중립",
  "Info": "정보",
  "Success": "성공",
  "Warning": "경고",
  "Critical": "심각",
  "Subdued": "흐림",
  "Transparent": "투명",
  "ThemeColor": "테마 색상",
  "ResetToDefaultColor": "{{label}}: 기본 색상으로 재설정",
  "OpenColorPicker": "{{label}}: 색상 선택기 열기",
  "Icon": "아이콘",
  "PackageIcon": "패키지 아이콘",
  "PackageIconNumber": "패키지 아이콘 {{value}}",
  "UploadIcon": "아이콘 업로드",
  "NoIcon": "아이콘 없음",
  "AcceptedFormats": "지원 형식: PNG, JPG, SVG",
  "MaximumFileSize": "최대 파일 크기: 50 MB",
  "AddFiles": "파일 추가",
  "RemoveImage": "이미지 제거",
  "Uploading": "업로드 중",
  "UploadFailedTryAgain": "업로드에 실패했습니다. 다시 시도하세요.",
  "ChooseAJPEGPNG": "최대 50 MB의 JPEG, PNG 또는 SVG 이미지를 선택하세요.",
  "ChooseNonemptyImage": "최대 50 MB의 비어 있지 않은 JPEG, JPG, PNG 또는 SVG 이미지를 선택하세요.",
  "ImageCouldNotBeRead": "이미지를 읽을 수 없습니다.",
  "FileContentsMismatch": "파일 내용이 JPEG, PNG 또는 SVG 이미지 유형과 일치해야 합니다.",
  "ImageCouldNotBeDecode": "이미지를 디코딩할 수 없습니다.",
  "InvalidImageUrl": "업로드 서비스에서 유효하지 않은 이미지 URL을 반환했습니다.",
  "MissingPublicImageUrl": "업로드 서비스에서 공개 이미지 URL을 반환하지 않았습니다.",
  "CustomCssTooLong": "사용자 지정 CSS는 최대 2,000자여야 합니다.",
  "ChooseValidIconUrl": "유효한 URL이 있는 업로드된 아이콘을 선택하세요.",
  "EnterNumberRange": "{{min}}에서 {{max}} 사이의 숫자를 입력하세요.",
  "EnterLocaleTextRange": "{{locale}} 텍스트를 1자에서 {{limit}}자 사이로 입력하세요.",
  "EnterValidLearnMoreUrl": "https:// 또는 http://로 시작하는 유효한 자세히 알아보기 URL을 입력하세요.",
  "ReviewHighlightedFields": "강조 표시된 필드를 검토하세요.",
  "CannotChangePublishState": "양식이 유효할 때까지 게시 상태를 변경할 수 없습니다: {{reason}}",
  "BlyCareCouldNotSave": "BlyCare에서 저장할 수 없습니다.",
  "CheckoutRequiresPlus": "결제 사용자 지정에는 Shopify Plus가 필요합니다.",
  "SaveSucceededReloadFailed": "저장 요청은 성공했지만 최신 위젯 설정을 불러올 수 없습니다. 변경 사항을 확인하려면 새로 고침하세요.",
  "BlyCareCouldNotComplete": "BlyCare에서 이 요청을 완료할 수 없습니다.",
  "ShopifyAuthorizationRequired": "Shopify 인증이 필요합니다.",
  "AppBridgeUnavailable": "Shopify App Bridge를 사용할 수 없습니다",
  "ExtensionStatusUnavailable": "Shopify 확장 상태를 사용할 수 없습니다.",
  "ConfigurationPreview": "구성 미리보기",
  "On": "켜짐",
  "Off": "꺼짐",
  "Unpublish": "게시 취소",
  "AppEmbedIsNotEnable": "앱 임베드가 활성화되지 않았습니다.",
  "GoEnabled": "활성화하러 가기",
  "ViewOnYourStorefront": "스토어프론트에서 보기",
  "PreviewProtection": "보호 미리보기",
  "MoreInformation": "자세한 정보",
  "Cart": "장바구니",
  "Subtotal": "소계",
  "Checkout": "결제",
  "DiscountCode": "할인 코드",
  "Apply": "적용",
  "Shipping": "배송",
  "Total": "합계",
  "ShippingProtection": "배송 보호",
  "Product": "상품",
  "CopyLink": "링크 복사"
}
